






























































































import { formatPrice } from '@/util/format'
import { PluginMixin } from '@spa/mixins/plugin'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  filters: {
    formatPrice,
  },
})
export default class Summary extends Mixins<PluginMixin>(PluginMixin) {
  @Prop()
  subtotal: string

  @Prop()
  shippings: number[]

  @Prop()
  commissions: number[]

  @Prop()
  total: string

  @Prop({ default: '' })
  bundleDiscountPrice: string

  @Prop({ default: '' })
  couponDiscountPrice: string

  @Prop({ default: '' })
  pointDiscountPrice: string

  @Prop({ required: true })
  estimatedPoints: number

  @Prop({ required: true })
  pointIsEnabled: boolean

  @Prop({ required: true })
  readonly serviceFees: number[]

  get totalShipping(): string {
    return formatPrice(_.sum(this.shippings))
  }
  get totalCommission(): string {
    return formatPrice(_.sum(this.commissions))
  }

  get hasServiceFee(): boolean {
    return this.serviceFees.length > 0
  }
  get totalServiceFee(): string {
    return formatPrice(_.sum(this.serviceFees))
  }

  mounted() {
    this.scrollToTop()
  }

  scrollToTop() {
    const scrolled = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop

    // tslint:disable-next-line
    window.scrollTo(0, Math.floor(scrolled / 2))
    if (scrolled > 0) {
      // tslint:disable-next-line
      window.setTimeout(this.scrollToTop, 30);
    }
  }
}
